<template>
  <div class="min-h-screen relative">
    <Header />

    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <div class="min-h-screen w-full container mx-auto ">
      <section
        id="UserProfile"
        v-if="profileInfo"
        class="w-full py-3 mt-10 flex flex-col md:flex-row flex-wrap gap-20 items-start justify-center "
      >
        <!-- Profile Card -->
        <div
          class="bg-white shadow-md rounded-lg p-5 text-center w-full md:w-[280px] mt-10"
        >
          <div class="flex flex-col items-center relative"> 


            <!-- {{ profileInfo.data.profile }} -->

            <div v-if="profileInfo.data.profile == ''">
              <!-- <p
                class="border rounded-full w-24 h-24 flex items-center justify-center text-4xl text-black capitalize bg-gray-200 font-semibold"
              >
                {{ profileInfo.data.user.slice(0, 1) }}
              </p> -->
              <!-- src="@/assets/new/profile.png" -->

              <img
                src="@/assets/new/image.png"
                alt="Profile Picture"
                class="w-24 h-24 rounded-full"
              />

            </div>
            <div v-else class="">

              

              <img
                :src="profileInfo.data.profile"
                alt="Profile Picture"
                class="w-24 h-24 rounded-full"
              />
            </div> 

            <p class="text-xs bg-blues text-white px-2 py-1 absolute top-0 right-0 rounded-lg cursor-pointer" @click="changeProfile = true">Edit</p>

            <form v-if="changeProfile" @submit.prevent="imageHandles" class="py-4 flex flex-col items-center justify-center gap-4 w-full">
                <input type="file" name="" id="image_uploads" required class="w-full">
                <div class="flex items-center gap-3"> 
                  <button type="submit" class="bg-blues text-white px-2 py-1 rounded-lg text-xs">Change Photo</button>
                  <button @click="changeProfile = false" class="bg-red-500 text-white px-2 py-1 rounded-lg text-xs">Cancel</button>
                </div>
                

              </form>

          </div>

          
          <div class="mt-4">
            <p class="text-lg font-bold capitalize">
              {{ profileInfo.data.user }}
            </p>
            <p class="text-sm text-gray-500">
              {{ profileInfo.data.designation }}
            </p>
          </div>
          <div class="mt-10 flex justify-center gap-5">
            <a :href="profileInfo.data.github" target="_blank" title="GitHub">
              <img
                src="@/assets/githubprofile.svg"
                class="h-6 w-6 cursor-pointer"
                alt="GitHub"
              />
            </a>
            <a
              :href="profileInfo.data.linkedin"
              target="_blank"
              title="LinkedIn"
              class="text-gray-500 hover:text-blue-500"
            >
              <svg
                fill="currentColor"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="0"
                class="w-6 h-6"
                viewBox="0 0 24 24"
              >
                <path
                  stroke="none"
                  d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"
                ></path>
                <circle cx="4" cy="4" r="2" stroke="none"></circle>
              </svg>
            </a>
          </div>
        </div>

        <!-- Personal Details Card -->
        <div
          class="flex flex-col gap-5 justify-center  px-6 md:py-10 w-full xl:w-[720px]  "
        >
          <div class="flex gap-3 items-center capitalize w-full  overflow-hidden ">
            <button
              :class="[
                active_tab == tab ? 'bg-blues text-white' : 'bg-gray-200',
              ]"
              class="px-4 py-2 rounded-md capitalize"
              v-for="tab in tabs"
              :key="tab"
              @click="active_tab = tab"
            >
              {{ tab }}
            </button>
          </div>
          <div
            v-if="active_tab == 'profile details'"
            class="w-full  flex flex-col gap-5 overflow-x-auto"
          >
            <div class="flex justify-between gap-2">
              <div class="text-[#0085DB] text-xl font-bold mt-2 p-4">
                Personal Details
              </div>
              <!-- <div @click="ProfileEdit" class="mt-8 relative">
                <button class="px-5 rounded border text-white bg-[#0F172A]">
                  Edit
                </button>
              </div> -->
            </div>
            <div class="flex flex-col gap-5 justify-center">
              <div class="overflow-x-auto">
                <table class="min-w-full bg-white border-gray-300">
                  <tbody>
                    <tr>
                      <td class="py-2 px-4 font-medium text-gray-800">
                        Full Name
                      </td>
                      <td>:</td>
                      <td class="py-2 px-4 text-gray-600">
                        {{ profileInfo.data.user }}
                      </td>
                    </tr>
                    <tr>
                      <td class="py-2 px-4 font-medium text-gray-800">Role</td>
                      <td>:</td>
                      <td class="py-2 px-4 text-gray-600 uppercase">
                        {{ this.userInfo.user.permission }}
                      </td>
                    </tr>
                    <tr>
                      <td class="py-2 px-4 font-medium text-gray-800">Email</td>
                      <td>:</td>
                      <td class="py-2 px-4 text-gray-600">
                        {{ profileInfo.data.Email }}
                      </td>
                    </tr>
                    <tr>
                      <td class="py-2 px-4 font-medium text-gray-800">
                        Mobile
                      </td>
                      <td>:</td>
                      <td class="py-2 px-4 text-gray-600">
                        {{ profileInfo.data.mobile }}
                      </td>
                    </tr>
                    <tr>
                      <td class="py-2 px-4 font-medium text-gray-800">Batch</td>
                      <td>:</td>
                      <td class="py-2 px-4 text-gray-600">
                        {{ profileInfo.data.batch || "None" }}
                      </td>
                    </tr>
                    <tr>
                      <td class="py-2 px-4 font-medium text-gray-800">
                        Department
                      </td>
                      <td>:</td>
                      <td class="py-2 px-4 text-gray-600">
                        {{ profileInfo.data.department || "None" }}
                      </td>
                    </tr>
                    <tr>
                      <td class="py-2 px-4 font-medium text-gray-800">
                        Program
                      </td>
                      <td>:</td>
                      <td class="py-2 px-4 text-gray-600">
                        {{ profileInfo.data.program || "None" }}
                      </td>
                    </tr>
                    <tr>
                      <td class="py-2 px-4 font-medium text-gray-800">
                        Semester
                      </td>
                      <td>:</td>
                      <td class="py-2 px-4 text-gray-600">
                        {{ profileInfo.data.semester || "None" }}
                      </td>
                    </tr>
                    <tr>
                      <td class="py-2 px-4 font-medium text-gray-800">
                        Section
                      </td>
                      <td>:</td>
                      <td class="py-2 px-4 text-gray-600">
                        {{ profileInfo.data.section || "None" }}
                      </td>
                    </tr>
                    <tr>
                      <td class="py-2 px-4 font-medium text-gray-800">
                        Section
                      </td>
                      <td>:</td>
                      <td class="py-2 px-4 text-gray-600">
                        {{ profileInfo.data.section || "None" }}
                      </td>
                    </tr>
                    <tr>
                      <td class="py-2 px-4 font-medium text-gray-800">
                        Address
                      </td>
                      <td>:</td>
                      <td class="py-2 px-4 text-gray-600">
                        {{ profileInfo.data.address || "None" }}
                      </td>
                    </tr>
                    <tr>
                      <td class="py-2 px-4 font-medium text-gray-800">
                        Description
                      </td>
                      <td>:</td>
                      <td class="py-2 px-4 text-gray-600">
                        {{
                          profileInfo.data.description.slice(0, 180) || "None"
                        }}
                        <p v-if="profileInfo.data.description.length > 180">
                          ...More
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="mt-4 flex justify-center rounded-xl gap-5">
                <div @click="ProfileEdit" class="relative">
                  <button class="px-4 py-2 rounded-lg text-white bg-[#0F172A]">
                    Edit
                  </button>
                </div>

                <div @click="ChangePasswordPopup" class="relative">
                  <button class="px-4 py-2 rounded-lg text-white bg-[#0F172A]">
                    Change Password
                  </button>
                </div>

                <!-- <router-link
                  class="flex items-center gap-2 px-4 py-2 text-white bg-[#0085DB] rounded-lg"
                >
                  <img
                    src="@/assets/newd/changee.png"
                    alt="Change Icon"
                    class="w-5 h-5"
                  />
                  <span class="text-sm font-medium">Change Password</span>
                </router-link> -->
              </div>
            </div>
          </div>
          <div
            v-if="active_tab == 'accessible course'"
            class="w-full  flex flex-col gap-5 py-5 overflow-x-auto "
          >
            <div
              class="w-full flex flex-wrap justify-between items-center gap-5 hidden"
            >
              <div
                v-for="course in course_list"
                :key="course"
                @click="redirectCourse"
                class="w-full md:w-[320px] xl:w-[350px] bg-lime-300 rounded-lg cursor-pointer"
              >
                <div class="w-full rounded-lg flex flex-col">
                  <div class="w-full h-[300px]">
                    <img
                      :src="course.thumbnail"
                      alt="Course Thumbnail"
                      class="w-full h-full object-cover rounded-t-lg"
                    />
                  </div>
                  <div class="w-full p-5 flex flex-col gap-3">
                    <h1 class="font-semibold text-black text-xl">
                      {{ course.title }}
                    </h1>
                    <p class="text-gray-700 font-medium text-md">
                      {{ course.description }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="w-full flex flex-col gap-5 ">
              <div class="w-full overflow-scroll">
                <table class="min-w-full">
                  <thead>
                    <tr
                      class="text-left bg-[#18469d] text whitespace-nowrap text-sm capitalize"
                    >
                      <th class="px-4 py-3">S.No</th>
                      <th class="px-4 py-3">Title</th>
                      <th class="px-4 py-3 hidden">description</th>
                      <th class="px-4 py-3">Course Code</th>
                      <th class="px-4 py-3">Section</th>
                      <th class="px-4 py-3">created at</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(course, index) in course_list"
                      :key="course.id"
                      @click="redirectCourse()"
                      class="border-b pb-3 text-sm w-full cursor-pointer hover:bg-gray-100 whitespace-nowrap "
                    >
                      <td class="px-4 py-3">
                        {{ (current_page - 1) * 10 + (index + 1) }}
                      </td>
                      <td class="px-4 py-3">{{ course.title }}</td>
                      <td class="px-4 py-3 hidden">
                        {{ course.short_description }}
                      </td>
                      <td class="px-4 py-3">{{ course.course_code }}</td>
                      <td class="px-4 py-3">{{ course.class_section }}</td>
                      <td class="px-4 py-3">
                        {{ formatDate(course.updated_at) }}
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr class="bg-[#18469d]">
                      <td colspan="5" class="p-4"></td>
                    </tr>
                  </tfoot>
                </table>
              </div>
              <Pagination
                :totalPages="totalPages"
                ref="paginationRef"
                @page-changed="this.getCourses"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
    <!-- PopUp -->
    <div
      v-if="popUp && updateDetails != null"
      class="fixed w-full min-h-screen bg-black bg-opacity-75 top-0 z-50 flex justify-center items-center"
    >
      <div
        class="w-[90%] md:w-5/6 lg:w-5/6 xl:w-3/6 2xl:w-2/6 h-full mx-auto flex flex-col items-center"
      >
        <div
          class="bg-white p-8 rounded-lg shadow-md w-full max-w-md flex flex-col gap-3"
        >
          <div class="flex items-center py-2 justify-between">
            <h2 class="text-lg lg:text-xl font-bold text-[#0085DB]">Edit Details</h2>
            <img
              class="h-5 w-5 md:h-8 md:w-8 cursor-pointer"
              @click="popUp = false"
              src="@/assets/closebutton.svg"
            />
          </div>
          <form class="">
            <div class="mb-4">
              <label class="block text-sm font-medium text-[#333333]"
                >Destination <span class="text-red-400">*</span></label
              >
              <input
                type="text"
                v-model="updateDetails.designation"
                class="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                placeholder="Student"
                required
              />
            </div>
            <div class="mb-4">
              <label class="block text-sm font-medium text-[#333333]"
                >Mobile <span class="text-red-400">*</span></label
              >
              <input
                type="text"
                v-model="updateDetails.mobile"
                class="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                placeholder="123456789"
                required
              />
            </div>
            <div class="mb-4">
              <label class="block text-sm font-medium text-[#333333]"
                >Address <span class="text-red-400">*</span></label
              >
              <input
                type="text"
                v-model="updateDetails.address"
                class="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                placeholder="21/2, Interting street, Common city - 365986"
                required
              />
            </div>
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-700"
                >Description <span class="text-red-400">*</span></label
              >
              <textarea
                class="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                placeholder="My name is this you can ask me what event it sear tire"
                required
                v-model="updateDetails.description"
              ></textarea>
            </div>
            <div class="mb-4">
              <label class="block text-sm font-medium text-[#333333]"
                >GitHub <span class="text-red-400">*</span></label
              >
              <input
                type="text"
                v-model="updateDetails.github"
                class="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                placeholder="Link"
                required
              />
            </div>
            <div class="mb-4">
              <label class="block text-sm font-medium text-[#333333]"
                >LinkedIn <span class="text-red-400">*</span></label
              >
              <input
                type="text"
                v-model="updateDetails.linkedin"
                class="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                placeholder="Link"
                required
              />
            </div>
            <div class="flex justify-center items-center w-full">
              <button
                @click="SubmitProfile()"
                type="submit"
                class="w-full max-w-[118px] h-[40px] px-4 py-2 bg-[#0F172A] text-white rounded-md hover:bg-blue-700 transition"
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div
      v-if="changePassword"
      class="fixed w-full min-h-screen bg-black bg-opacity-75 top-0 z-50 flex justify-center items-center"
    >
      <div
        class="w-[90%] md:w-5/6 lg:w-5/6 xl:w-3/6 2xl:w-2/6 h-full mx-auto flex flex-col items-center"
      >
        <div
          class="bg-white p-8 rounded-lg shadow-md w-full max-w-md flex flex-col gap-3"
        >
          <div class="flex items-center py-2 justify-between">
            <h2 class="text-2xl font-bold text-[#0085DB]">Change Password</h2>
            <img
              class="h-5 w-5 md:h-8 md:w-8 cursor-pointer"
              @click="changePassword = false"
              src="@/assets/closebutton.svg"
            />
          </div>
          <form @submit.prevent="changepassword">
            <div class="mb-4">
              <label class="block text-sm font-medium text-[#333333]"
                >Old Password <span class="text-red-400">*</span></label
              >

              <div class="flex items-center relative">
                <input
                  type="password"
                  id="oldpassword"
                  class="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                  placeholder="Old Password"
                  required
                />

                <img
                  v-if="passwordType == 'oldpassword'"
                  src="@/assets/eyeslash.svg"
                  @click="hideShow('oldpassword')"
                  alt=""
                  class="cursor-pointer inline-block z-50 absolute bg-white right-4"
                />
                <img
                  v-else
                  src="@/assets/eye.svg"
                  @click="hideShow('oldpassword')"
                  alt=""
                  class="cursor-pointer inline-block z-50 absolute bg-white right-4"
                />
              </div>
            </div>
            <div class="mb-4">
              <label class="block text-sm font-medium text-[#333333]"
                >New Password <span class="text-red-400">*</span></label
              >
              <!-- <input
                type="password"
                id="oldtoNew"
                class="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                placeholder="New Password"
                required
              />
              <img v-if="passwordType == 'password'" src="@/assets/eyeslash.svg" @click="hideShow('oldtoNew')"
                        alt="" class="cursor-pointer inline-block z-50" style="margin-left: -30px" />
                    <img v-else src="@/assets/eye.svg" @click="hideShow('oldtoNew')" alt=""
                        class="cursor-pointer inline-block z-50" style="margin-left: -30px" /> -->

              <div class="flex items-center relative">
                <input
                  type="password"
                  id="oldtoNew"
                  class="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                  placeholder="New Password"
                  required
                />

                <img
                  v-if="passwordType == 'oldtoNew'"
                  src="@/assets/eyeslash.svg"
                  @click="hideShow('oldtoNew')"
                  alt=""
                  class="cursor-pointer inline-block z-50 absolute bg-white right-4"
                />
                <img
                  v-else
                  src="@/assets/eye.svg"
                  @click="hideShow('oldtoNew')"
                  alt=""
                  class="cursor-pointer inline-block z-50 absolute bg-white right-4"
                />
              </div>
            </div>

            <div class="mb-4">
              <label class="block text-sm font-medium text-[#333333]"
                >New Confirm Password <span class="text-red-400">*</span></label
              >

              <div class="flex items-center relative">
                <input
                  type="password"
                  id="changeconfirm"
                  class="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                  placeholder="New Confirm Password"
                  required
                />

                <img
                  v-if="passwordType == 'changeconfirm'"
                  src="@/assets/eyeslash.svg"
                  @click="hideShow('changeconfirm')"
                  alt=""
                  class="cursor-pointer inline-block z-50 absolute bg-white right-4"
                />
                <img
                  v-else
                  src="@/assets/eye.svg"
                  @click="hideShow('changeconfirm')"
                  alt=""
                  class="cursor-pointer inline-block z-50 absolute bg-white right-4"
                />
              </div>

              <!-- <input
                type="password"
                id="changeconfirm"
                class="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                placeholder="New Confirm Password"
                required
              />
              <img v-if="passwordType == 'password'" src="@/assets/eyeslash.svg" @click="hideShow('changeconfirm')"
                        alt="" class="cursor-pointer inline-block z-50" style="margin-left: -30px" />
                    <img v-else src="@/assets/eye.svg" @click="hideShow('changeconfirm')" alt=""
                        class="cursor-pointer inline-block z-50" style="margin-left: -30px" /> -->
            </div>

            <div class="flex justify-center items-center w-full">
              <button
                type="submit"
                class="w-full px-4 py-2 bg-[#0F172A] text-white rounded-md hover:bg-blue-700 transition"
              >
                Change Password
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div
      id="image_uploads"
      class="bg-white rounded-lg shadow-sm w-[350px] outline-none"
    >
      <!-- Your content here -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import FlashMessage from "@/components/FlashMessage.vue";
import { mapGetters, mapMutations } from "vuex";
import Header from "@/components/Student/Header.vue";
import Pagination from "@/components/Pagination.vue";
import { faLaugh } from "@fortawesome/free-regular-svg-icons";

export default {
  data() {
    return {
      profileInfo: null,
      popUp: false,
      updateDetails: null,
      selectedFile: null,
      tnxDetails: "",
      profile: false,
      messages: {
        text: "",
        type: "null",
      },
      selectedcontent: "Courses",
      courseDetails: null,
      boughtcourse: null,
      changePassword: false,
      passwordType: "password",
      tabs: ["profile details", "accessible course"],
      active_tab: "profile details",
      course_list: "",
      totalPages: 1,
      current_page: 1,
      course_count: null,
      loading: false,
      selectedInstructors: [],
      changeProfile: false,
    };
  },

  components: {
    Header,
    FlashMessage,
    Pagination,
  },

  computed: {
    ...mapGetters(["userInfo"]),
  },

  async created() {
    await this.openProcess();
    await this.getCourses(1);
  },

  methods: { 

    ...mapMutations(["updateImage"]),

    hideShow(id) {
      const passwordField = document.querySelector(`#${id}`);
      passwordField.getAttribute("type") === "password"
        ? passwordField.setAttribute("type", "text")
        : passwordField.setAttribute("type", "password");
      if (this.passwordType == id) {
        this.passwordType = "password";
      } else {
        this.passwordType = id;
      }
    },

    ChangePasswordPopup() {
      this.changePassword = true;
    },

    async changepassword() {
      let oldpassWord = document.querySelector("#oldpassword").value;
      let newpassword = document.querySelector("#oldtoNew").value;
      let confirmpassword = document.querySelector("#changeconfirm").value;
      if (newpassword == confirmpassword) {
        var responseMail;
        let loginHeader = {
          username: this.userInfo.user.email,
          password: oldpassWord,
        };
        // OldPassword Validations

        await axios
          .post(`${process.env.VUE_APP_API}/login`, loginHeader)
          .then((response) => {
            if (response.data.user) {
              responseMail = response.data.user.email;
            } else {
              responseMail = "error";
            }
          });

        if (responseMail == this.userInfo.user.email) {
          const headerVal = {
            old_password: document.querySelector("#oldpassword").value,
            new_password: document.querySelector("#changeconfirm").value,
          };
          await axios
            .put(
              `${process.env.VUE_APP_API}/api/change-password/?Key=${this.userInfo.token_key}`,
              headerVal
            )
            .then((response) => {
              if (response.data.message == "Password updated successfully") {
                this.messages = {
                  text: "Password updated successfully",
                  type: "success",
                };
              } else {
                this.messages = {
                  text: " Event Faild",
                  type: "error",
                };
              }
            })
            .catch((error) => {
              console.log(error);
            });
          document.querySelector("#oldpassword").value = "";
          document.querySelector("#oldtoNew").value = "";
          document.querySelector("#changeconfirm").value = "";

          this.changePassword = false;

          setTimeout(() => {
            this.messages = {
              text: " ",
              type: "",
            };
            // this.$router.push({
            //     name: 'Home'
            // })
          }, 3000);
        } else {
          this.errorMessage = {
            text: " Old Password Not Matching",
            type: "error",
          };

          setTimeout(() => {
            this.errorMessage = {
              text: " ",
              type: "",
            };
          }, 1500);
        }
      } else {
        console.log("error");
        this.errorMessage = {
          text: " Confirm Password Miss Match",
          type: "error",
        };
        setTimeout(() => {
          this.errorMessage = {
            text: " ",
            type: "",
          };
        }, 1500);
      }
    },

    async imageHandles() {
      this.profile = false;
      let headerprofile = new FormData();
      headerprofile.append("id", this.userInfo.user.id);
      headerprofile.append(
        "profile",
        document.querySelector("#image_uploads").files[0]
      );

      await axios
        .put(
          `${process.env.VUE_APP_API}/upload_photo/?Key=${this.userInfo.token_key}`,
          headerprofile
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: "Profile Uploaded successfully",
              type: "success",
            };
            this.openProcess();
            this.updateImage(`${response.data.data.profile}`);
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
          }
        })
        .catch((error) => {
          this.messages = { 
            text: error.response.data.error,
            type: "error",
          };
        });

      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
        // this.openProcess();
        this.changeProfile = false;
        // window.location.reload();
        // setTimeout(()=>{
        //   this.updateImage(this.profileInfo.data.profile);
        // }, 50)        
      }, 3000);
    },

    onFileChanged(event) {
      this.selectedFile = event.target.files[0];
    },

    async onUpload() {
      // upload file
      await axios.post("my-domain.com/file-upload", this.selectedFile);
    },

    async openProcess() {
      axios
        .get(
          `${process.env.VUE_APP_API}/paymentlist/?Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          console.log(res);
          this.tnxDetails = res.data;
        });
      let token = this.userInfo.token_key;
      let slug_id = this.userInfo.slug_id;

      await axios
        .get(
          `${process.env.VUE_APP_API}/profile_detail/?Key=${token}&format=json`
        )
        .then((response) => (this.profileInfo = response.data));
      console.log("this.profileInfo", this.profileInfo);
    },

    async ProfileEdit() {
      let details_id = this.profileInfo.data.id;
      let token = this.userInfo.token_key;
      this.popUp = true;

      await axios
        .get(
          `${process.env.VUE_APP_API}/profile_update/${details_id}?Key=${token}&format=json`
        )
        .then((response) => (this.updateDetails = response.data.data));
      console.log("this.updateDetails", this.updateDetails);
    },

    async SubmitProfile() {
      let details_id = this.profileInfo.data.id;
      let token = this.userInfo.token_key;
      let update = this.updateDetails;
      this.popUp = false;
      console.log("updateDetails123", update);

      await axios
        .put(
          `${process.env.VUE_APP_API}/profile_update/${details_id}/?Key=${token}&format=json`,
          update
        )
        .then((response) => {
          if (response.data.message == "Profile updated successfully") {
            this.messages = {
              text: "Profile Uploaded successfully",
              type: "success",
            };
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
          }
        });

      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
        this.openProcess();
      }, 3000);
    },
    // access course

    async getCourses(page) {
      await axios
        .get(
          `${process.env.VUE_APP_API}/courses/?page=${page}&Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response.data.data.data.status == 200) {
            this.totalPages = response.data.data.total_page;
            this.current_page = response.data.data.current_page;
            this.course_list = response.data.data.data.data;
            this.selectedInstructors = this.course_list;
            this.course_count = response.data.data.total;
            this.loading = false;
          } else if (response.data.status == 400) {
            this.course_count = 0;
            this.course_list = [];
          }
        })
        .catch((err) => {
          console.log("error", err);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 600);
        });
    },
    formatDate(dateStr) {
      const date = new Date(dateStr);
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
  },
};
</script>

<style scoped>
/* #image_uploads {
  background-color: white;
  border-radius: 5px;
  box-shadow: 2px 2px 4px black;
  width: 350px;
  outline: none;
} */
</style>
